<div *samwebVar="step$ | async; let step">
   <div
      class="sam-form-flex-row component"
      #slider
      (mouseenter)="isMouseOverComponent = true"
      (mouseleave)="isMouseOverComponent = false"
   >
      <fa-icon
         [icon]="phoneticIcon"
         [fixedWidth]="true"
         [ngClass]="
            step === 0 ? 'sam-margin-left  sam-center slider-icon' : 'sam-margin-left  sam-center slider-icon-active'
         "
         (click)="togglePhoneticSearch(step)"
      ></fa-icon>
      <div class="slider-container sam-margin-right-medium">
         <kendo-slider
            class="sam-full-width sam-center slider"
            [min]="0"
            [max]="3"
            [ngModel]="step"
            [smallStep]="1"
            (valueChange)="onChange($event)"
            [showButtons]="false"
         >
            <kendo-slider-messages increment="Right" decrement="Left"></kendo-slider-messages>
         </kendo-slider>
      </div>
   </div>

   <kendo-popup
      *ngIf="isMouseOverComponent"
      class="k-tooltip sam-margin-top"
      popupClass="popup-content"
      [anchor]="slider"
      [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
      [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
   >
      <div class="sam-form-flex-row sam-center">
         <div class="sam-margin-right">{{ 'phonetic.title' | translate }}</div>
         <div [ngClass]="step === 0 ? ' text-bold' : ' text-smaller'">
            {{ sliderEnum[0].translationValue | translate }}
         </div>
         <div class="sam-margin-left sam-margin-right">{{ ' | ' }}</div>
         <div [ngClass]="step === 1 ? ' text-bold' : ' text-smaller'">
            {{ sliderEnum[1].translationValue | translate }}
         </div>
         <div class="sam-margin-left sam-margin-right">{{ ' | ' }}</div>
         <div [ngClass]="step === 2 ? ' text-bold' : ' text-smaller'">
            {{ sliderEnum[2].translationValue | translate }}
         </div>
         <div class="sam-margin-left sam-margin-right">{{ ' | ' }}</div>
         <div [ngClass]="step === 3 ? ' text-bold' : ' text-smaller'">
            {{ sliderEnum[3].translationValue | translate }}
         </div>
      </div>
   </kendo-popup>
</div>
